const TablePosition = require('../TablePosition')

/**
 * Remove current row in a table. Clear it if last remaining row
 *
 * @param {Object} opts
 * @param {Slate.Transform} transform
 * @param {Number} at
 * @return {Slate.Transform}
 */
function removeAccordionRow (opts, transform, at) {
  const { state } = transform
  const { startBlock } = state

  const pos = TablePosition.create(state, startBlock, opts)
  const { table } = pos

  if (typeof at === 'undefined') {
    at = pos.getRowIndex()
  }

  const row1 = table.nodes.get(at)
  let row2
  let direction = row1.data.get('isAccordionTitle') ? 1 : -1
  let otherAt = at + direction
  // get other half of this accordion pair
  row2 = table.nodes.get(otherAt)

    // Update table by removing the row
  if (pos.getHeight() > 2) {
    let focusIndex = Math.min(at, otherAt) - 1
    if (focusIndex < 0) focusIndex = 0
    transform.removeNodeByKey(row1.key)
    transform.removeNodeByKey(row2.key)
    transform
      .collapseToEndOf(table.nodes.get(focusIndex).nodes.get(0))
      .focus()
  } else {
    transform.removeNodeByKey(table.key)
  }

  return transform
}

module.exports = removeAccordionRow



// WEBPACK FOOTER //
// ./src/components/DeepTableSlatePlugin/deep-table-plugin/transforms/removeAccordionRow.js